import { render } from "./AdmissionCard.vue?vue&type=template&id=690cddae&scoped=true"
import script from "./AdmissionCard.vue?vue&type=script&lang=js"
export * from "./AdmissionCard.vue?vue&type=script&lang=js"

import "./AdmissionCard.vue?vue&type=style&index=0&id=690cddae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690cddae"]])

export default __exports__